webpackJsonp([127285901798155],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"D:/projekty/Calipsy/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"D:/projekty/Calipsy/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"D:/projekty/Calipsy/node_modules/babel-preset-stage-0/lib/index.js\",\"D:/projekty/Calipsy/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/content.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Commons = __webpack_require__("./src/Components/Shared/Commons.js");
	
	var _translations = __webpack_require__("./translations/index.js");
	
	var _index = __webpack_require__("./src/components/SEO/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__("./src/components/Newsletter/index.js");
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //---------	Global imports
	
	
	//---------  Plugins
	
	
	//---------	Translations
	
	
	//---------	Components
	
	
	var ContentTemplate = function (_React$Component) {
	  _inherits(ContentTemplate, _React$Component);
	
	  //---------	Constructor
	  function ContentTemplate() {
	    _classCallCheck(this, ContentTemplate);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      loading: true
	    };
	    return _this;
	  }
	
	  //---------	React functions
	
	
	  ContentTemplate.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ loading: false });
	    }, 300);
	    setTimeout(function () {
	      return (0, _Commons.onTemplateLoad)();
	    });
	  };
	
	  ContentTemplate.prototype.render = function render() {
	    var data = this.props.data.markdownRemark.frontmatter;
	    var seo = {
	      title: data.title + ' | Calipsy'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { className: this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper' },
	      _react2.default.createElement(_index2.default, seo),
	      _react2.default.createElement('div', { className: 'CalipsySpinner' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'CalipsyWrapper-container' },
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.data.markdownRemark.html } }),
	        data.newsletter ? _react2.default.createElement(_index4.default, { alternateContent: true }) : null
	      )
	    );
	  };
	
	  return ContentTemplate;
	}(_react2.default.Component);
	
	exports.default = ContentTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-content-js-e050f698ab3108f5f665.js